import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/check.png'


const _withScopeId = n => (_pushScopeId("data-v-d39b6452"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = {
  key: 0,
  class: "contacted-row"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Contacted", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "contacted",
  src: _imports_0
}, null, -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 3 }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  key: 6,
  class: "modal-window"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  class: "btn",
  type: "submit",
  value: "Send Message"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.$parent!.all_emails.includes(_ctx.$props.email))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
      : _createCommentVNode("", true),
    (_ctx.$props.name != null)
      ? (_openBlock(), _createElementBlock("h5", _hoisted_6, _toDisplayString(_ctx.$props.name), 1))
      : _createCommentVNode("", true),
    (_ctx.$props.email != null)
      ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.$props.email), 1))
      : _createCommentVNode("", true),
    (_ctx.$props.message != null)
      ? (_openBlock(), _createElementBlock("h5", _hoisted_8, "Message"))
      : _createCommentVNode("", true),
    (_ctx.$props.message != null)
      ? (_openBlock(), _createElementBlock("p", {
          key: 4,
          innerHTML: _ctx.$props.message
        }, null, 8, _hoisted_9))
      : _createCommentVNode("", true),
    (!_ctx.showMessageWindow)
      ? (_openBlock(), _createElementBlock("button", {
          key: 5,
          class: "btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showMessageWindow = true))
        }, "Send Email"))
      : _createCommentVNode("", true),
    (_ctx.showMessageWindow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("h4", {
            class: "close-button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showMessageWindow = false))
          }, "X Close Window"),
          _createElementVNode("form", {
            id: "emailForm",
            onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.sendEmail(_ctx.$props.email, _ctx.$props.name)), ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("textarea", {
              id: "newMessage",
              name: "message",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newMessage) = $event)),
              placeholder: "Your message ..."
            }, null, 512), [
              [_vModelText, _ctx.newMessage]
            ]),
            _hoisted_11
          ], 32)
        ]))
      : _createCommentVNode("", true)
  ]))
}